module.exports = {
	"checkIpv4CidrIsOverlap": "/api/cps/checkIpv4CidrIsOverlap", // 检查ipv4 cidr是否重叠
	"peeringQuota": "/api/cps/peerConn/queryPeerQuota", //获取对等连接配额
	"peerRegions": "/api/cps/getPeerRegions", //获取支持对等链接的地域
	"addPeerConn": "/api/cps/peerConn/addPeerConn", // 创建对等链接
};



// WEBPACK FOOTER //
// ./src/api/peering/create/config.js